import { render, staticRenderFns } from "./Dice.vue?vue&type=template&id=065437c6&scoped=true&"
import script from "./Dice.vue?vue&type=script&lang=js&"
export * from "./Dice.vue?vue&type=script&lang=js&"
import style0 from "./Dice.vue?vue&type=style&index=0&id=065437c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065437c6",
  null
  
)

export default component.exports